import { useState } from "react";

import PageHeader from "../components/UI/PageHeader";
import PersonalInfo from "../components/section/PersonalInfo";
import CompanyInfo from "../components/section/CompanyInfo";

const TelegramAccountInfo = () => {
  const [confirmation, setConfirmation] = useState(false);

  return (
    <div className="w-full min-h-screen bg-gray-100">
      <PageHeader title="Account Information" />
      <div className="w-full max-w-[600px] mx-auto px-4 py-6 pb-10 space-y-5">
        {confirmation && (
          <div className="bg-white border border-green-500 text-green-600 rounded-xl py-3 text-center text-sm">
            Saved
          </div>
        )}
        <div className="bg-white rounded-2xl p-5 shadow-[0_2px_10px_rgba(0,0,0,0.05)]">
          <h2 className="text-sm font-semibold text-[#3d5984] mb-4">
            Personal
          </h2>
          <PersonalInfo onSuccess={setConfirmation} />
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-[0_2px_10px_rgba(0,0,0,0.05)]">
          <h2 className="text-sm font-semibold text-[#3d5984] mb-4">
            Company
          </h2>
          <CompanyInfo />
        </div>
      </div>
    </div>
  );
};

export default TelegramAccountInfo;
